import { Flex } from "@similarweb/ui-components/foundations";

import {
    StyledLeadsPageActionsWrapper,
    StyledLeadsPageHeaderWrapper,
} from "app/pages/sales-intelligence/common-components/layout";
import { useActiveListOption } from "app/pages/sales-intelligence/modules/lists/hooks/useActiveListOption";
import DataCreditsIndicatorContainer from "app/pages/sales-intelligence/modules/quota/containers/DataCreditsIndicatorContainer/DataCreditsIndicatorContainer";

import { StyledPageTitleDropdown } from "../../components/PageTitleButton/styles";
import CrmListPageTitleButtonContainer from "../PageTitleButton/CrmListPageTitleButtonContainer";
import WithEducationBar from "../WithEducationBar/WithEducationBar";

const CrmListPageHeaderContainer = () => {
    const activeListOption = useActiveListOption();

    return (
        <WithEducationBar>
            {({ educationBarButton }) => (
                <StyledLeadsPageHeaderWrapper>
                    {activeListOption ? (
                        <StyledPageTitleDropdown
                            renderDropdownButton={CrmListPageTitleButtonContainer}
                            selectedList={activeListOption}
                        />
                    ) : null}

                    <Flex
                        gap="8px"
                        alignItems="center"
                    >
                        <DataCreditsIndicatorContainer />
                        <StyledLeadsPageActionsWrapper>{educationBarButton}</StyledLeadsPageActionsWrapper>
                    </Flex>
                </StyledLeadsPageHeaderWrapper>
            )}
        </WithEducationBar>
    );
};

export default CrmListPageHeaderContainer;
